import languagePermissionProvider from "./languagePermissionProvider";
import MasterdataPermissionProvider from "./MasterdataPermissionProvider";
import ERPPermissionProvider from "./ERPPermissionProvider";
import AttributeTypePermissionProvider from "./AttributeTypePermissionProvider";
import MediaAssetTypePermissionProvider from "./MediaAssetTypePermissionProvider";
import RootCatalogNodePermissionProvider from "./RootCatalogNodePermissionProvider";
import TreePermissionProvider from "./TreePermissionProvider";
import CatalogNodePermissionProvider from "./CatalogNodePermissionProvider";
import CatalogMasterdataPermissionProvider from "./CatalogMasterdataPermissionProvider";

const providers = {
  Language: languagePermissionProvider,
  MasterData: MasterdataPermissionProvider,
  ErpSection: ERPPermissionProvider,
  AttributeType: AttributeTypePermissionProvider,
  MediaAssetType: MediaAssetTypePermissionProvider,
  RootCatalogNode: RootCatalogNodePermissionProvider,
  TreeCatalogNode: TreePermissionProvider,
  CatalogNode: CatalogNodePermissionProvider,
  CatalogMasterdata: CatalogMasterdataPermissionProvider
};

export default {
  canRead(context) {
    const permits = context.permissions || ["Language"];
    return permits.every((provider) => !!providers?.[provider]?.canRead(context));
  },
  canWrite(context) {
    const permits = context.permissions || ["Language"];
    return permits.every((provider) => !!providers?.[provider]?.canWrite(context));
  },
  canDelete(context) {
    const permits = context.permissions || ["Language"];
    return permits.every((provider) => !!providers?.[provider]?.canDelete(context));
  }
};
